<template>
  <div>
    <div class="block-container">
      <div class="flex">
        <transition name="fade">
          <button
            v-if="!openBurgerMenu"
            @click="openBurgerMenu = true"
            class="burger"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_509_1508)">
                <path d="M24 11.0006H0V13.0006H24V11.0006Z" fill="white" />
                <path d="M24 4.00024H0V6.00024H24V4.00024Z" fill="white" />
                <path d="M24 18H0V20H24V18Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_509_1508">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </transition>
        <RouterLink class="logo" :to="{ path: '/monitoring' }">
          <img
            src="../assets/images/brand_logo_dark.png"
            alt="logo"
          />
        </RouterLink>
        <!--        <img class="logo" src="../assets/images/geologistic_logo_white_all.png" alt="logo">-->
        <nav class="navigation">
          <ul>
            <li
              class="navigation-item"
              :class="{ active: routeName === 'MonitoringView' }"
            >
              <a @click.prevent="$router.push('/monitoring')">
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.8531 10.4986C11.5059 10.4986 12.1441 10.3031 12.6869 9.9368C13.2297 9.57053 13.6527 9.04994 13.9025 8.44085C14.1524 7.83176 14.2177 7.16154 14.0904 6.51494C13.963 5.86833 13.6487 5.27439 13.187 4.80821C12.7254 4.34204 12.1373 4.02457 11.4971 3.89595C10.8568 3.76734 10.1931 3.83335 9.59003 4.08564C8.98691 4.33793 8.47142 4.76517 8.10874 5.31334C7.74606 5.8615 7.55248 6.50597 7.55248 7.16524C7.55248 8.04929 7.90023 8.89714 8.51922 9.52226C9.13821 10.1474 9.97775 10.4986 10.8531 10.4986ZM10.8531 5.49857C11.1795 5.49857 11.4986 5.59632 11.77 5.77946C12.0414 5.96259 12.2529 6.22289 12.3778 6.52743C12.5027 6.83198 12.5354 7.16709 12.4718 7.49039C12.4081 7.81369 12.2509 8.11066 12.0201 8.34375C11.7893 8.57684 11.4952 8.73557 11.1751 8.79988C10.855 8.86419 10.5231 8.83118 10.2216 8.70504C9.92002 8.57889 9.66228 8.36527 9.48094 8.09119C9.2996 7.81711 9.20281 7.49487 9.20281 7.16524C9.20281 6.72321 9.37668 6.29929 9.68618 5.98673C9.99567 5.67417 10.4154 5.49857 10.8531 5.49857ZM14.1538 18.8569L20.7551 20.4802V11.7344C20.7549 11.1976 20.5837 10.6752 20.2667 10.2443C19.9497 9.81343 19.5039 9.49703 18.995 9.34191L17.2622 8.75857C17.3889 8.23879 17.4534 7.70554 17.4544 7.17024C17.4544 5.40213 16.759 3.70643 15.521 2.45619C14.283 1.20595 12.6039 0.503571 10.8531 0.503571C9.10236 0.503571 7.42329 1.20595 6.18531 2.45619C4.94732 3.70643 4.25183 5.40213 4.25183 7.17024C4.25427 7.50852 4.28185 7.84613 4.33434 8.18024C3.95961 8.02937 3.55398 7.97353 3.15293 8.01761C2.75189 8.06169 2.36765 8.20435 2.03382 8.4331C1.7 8.66185 1.42677 8.96973 1.23804 9.3298C1.0493 9.68987 0.950806 10.0912 0.951173 10.4986V18.6252L7.53845 20.5261L14.1538 18.8569ZM7.35197 3.63524C8.28213 2.7092 9.53695 2.19188 10.8431 2.19597C12.1492 2.20006 13.4008 2.72523 14.3253 3.65708C15.2498 4.58893 15.7721 5.85195 15.7787 7.17101C15.7852 8.49007 15.2753 9.75829 14.3601 10.6994L10.8531 14.1652L7.35197 10.7061C6.42355 9.7684 5.90197 8.49668 5.90197 7.17066C5.90197 5.84463 6.42355 4.57291 7.35197 3.63524V3.63524ZM2.6015 10.4986C2.60046 10.3611 2.63361 10.2256 2.69791 10.1045C2.76221 9.98334 2.8556 9.88045 2.96952 9.80524C3.08869 9.72626 3.22597 9.67956 3.36816 9.66964C3.51036 9.65971 3.65269 9.68689 3.78148 9.74857L4.96477 10.1802C5.28135 10.8134 5.69552 11.3917 6.19179 11.8936L10.8531 16.4986L15.5211 11.8877C15.9801 11.4249 16.3693 10.8965 16.6763 10.3194L18.5057 10.9369C18.678 10.9867 18.8296 11.0917 18.9375 11.2362C19.0454 11.3807 19.1039 11.5568 19.1039 11.7377V18.3619L14.1538 17.1402L7.56898 18.8069L2.6015 17.3702V10.4986Z"
                  />
                </svg>
                Мониторинг
              </a>
            </li>
            <li
              class="navigation-item"
              :class="{ active: routeName === 'ObjectsView' }"
            >
              <a @click.prevent="$router.push('/objects')">
                <svg
                  width="18"
                  height="20"
                  viewBox="0 0 18 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1_1558)">
                    <path
                      d="M14.1033 4.16616H12.6485V3.33282C12.6485 2.66978 12.4186 2.0339 12.0094 1.56506C11.6001 1.09622 11.0451 0.832825 10.4663 0.832825H2.46492C1.88616 0.832825 1.33111 1.09622 0.921867 1.56506C0.512625 2.0339 0.282715 2.66978 0.282715 3.33282L0.282715 15.8328H1.76734C1.74862 15.9707 1.73866 16.11 1.73752 16.2495C1.73752 17.023 2.00575 17.7649 2.48319 18.3119C2.96064 18.8589 3.60821 19.1662 4.28342 19.1662C4.95864 19.1662 5.6062 18.8589 6.08365 18.3119C6.5611 17.7649 6.82932 17.023 6.82932 16.2495C6.82818 16.11 6.81822 15.9707 6.7995 15.8328H11.2236C11.2048 15.9707 11.1949 16.11 11.1937 16.2495C11.1937 17.023 11.462 17.7649 11.9394 18.3119C12.4169 18.8589 13.0644 19.1662 13.7396 19.1662C14.4149 19.1662 15.0624 18.8589 15.5399 18.3119C16.0173 17.7649 16.2855 17.023 16.2855 16.2495C16.2844 16.11 16.2744 15.9707 16.2557 15.8328H17.7403V8.33282C17.7392 7.22816 17.3556 6.16912 16.6738 5.38801C15.992 4.60689 15.0676 4.16748 14.1033 4.16616ZM14.1033 5.83282C14.6821 5.83282 15.2371 6.09622 15.6464 6.56506C16.0556 7.0339 16.2855 7.66978 16.2855 8.33282V9.16616H12.6485V5.83282H14.1033ZM5.37452 16.2495C5.37452 16.581 5.25957 16.899 5.05495 17.1334C4.85033 17.3678 4.5728 17.4995 4.28342 17.4995C3.99404 17.4995 3.71652 17.3678 3.5119 17.1334C3.30727 16.899 3.19232 16.581 3.19232 16.2495C3.19277 16.1071 3.21568 15.9659 3.25997 15.8328H5.30687C5.35116 15.9659 5.37408 16.1071 5.37452 16.2495ZM11.1937 14.1662H1.73752V3.33282C1.73752 3.11181 1.81415 2.89985 1.95057 2.74357C2.08698 2.58729 2.272 2.49949 2.46492 2.49949H10.4663C10.6592 2.49949 10.8443 2.58729 10.9807 2.74357C11.1171 2.89985 11.1937 3.11181 11.1937 3.33282V14.1662ZM14.8307 16.2495C14.8307 16.581 14.7158 16.899 14.5112 17.1334C14.3065 17.3678 14.029 17.4995 13.7396 17.4995C13.4503 17.4995 13.1727 17.3678 12.9681 17.1334C12.7635 16.899 12.6485 16.581 12.6485 16.2495C12.6489 16.1071 12.6718 15.9659 12.7162 15.8328H14.7631C14.8075 15.9659 14.8304 16.1071 14.8307 16.2495ZM12.6485 14.1662V10.8328H16.2855V14.1662H12.6485Z"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_1558">
                      <rect
                        width="17.4576"
                        height="20"
                        transform="translate(0.282715)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                Объекты
              </a>
            </li>
            <li
              v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
              class="navigation-item"
              :class="{ active: routeName === 'UsersView' }"
            >
              <a @click.prevent="$router.push('/users')">
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1_1562)">
                    <path
                      d="M17.8316 20.7512H16.1664V16.5487C16.1658 15.8954 15.9062 15.269 15.4446 14.807C14.9831 14.3451 14.3572 14.0852 13.7045 14.0846H6.97229C6.31955 14.0852 5.69374 14.3451 5.23218 14.807C4.77062 15.269 4.51103 15.8954 4.51037 16.5487V20.7512H2.84521V16.5487C2.84654 15.4536 3.28178 14.4037 4.05547 13.6293C4.82916 12.8549 5.87813 12.4192 6.97229 12.4179H13.7045C14.7987 12.4192 15.8476 12.8549 16.6213 13.6293C17.395 14.4037 17.8303 15.4536 17.8316 16.5487V20.7512Z"
                    />
                    <path
                      d="M10.3382 10.7507C9.35022 10.7507 8.3844 10.4574 7.5629 9.90802C6.74141 9.35861 6.10113 8.57772 5.72303 7.66409C5.34494 6.75046 5.24601 5.74513 5.43876 4.77522C5.63151 3.80532 6.10728 2.9144 6.80591 2.21514C7.50454 1.51588 8.39464 1.03967 9.36367 0.846747C10.3327 0.653821 11.3371 0.752838 12.2499 1.13128C13.1627 1.50971 13.9429 2.15058 14.4918 2.97282C15.0407 3.79507 15.3337 4.76177 15.3337 5.75067C15.3324 7.07635 14.8056 8.34735 13.8691 9.28475C12.9325 10.2221 11.6627 10.7493 10.3382 10.7507V10.7507ZM10.3382 2.41734C9.67956 2.41734 9.03568 2.61284 8.48801 2.97911C7.94035 3.34538 7.51349 3.86598 7.26143 4.47506C7.00937 5.08415 6.94342 5.75437 7.07192 6.40097C7.20042 7.04758 7.5176 7.64152 7.98335 8.1077C8.4491 8.57387 9.0425 8.89134 9.68852 9.01996C10.3345 9.14858 11.0041 9.08256 11.6127 8.83027C12.2212 8.57798 12.7413 8.15074 13.1073 7.60257C13.4732 7.05441 13.6685 6.40994 13.6685 5.75067C13.6685 4.86662 13.3177 4.01877 12.6931 3.39365C12.0686 2.76853 11.2215 2.41734 10.3382 2.41734Z"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_1562">
                      <rect
                        width="19.9818"
                        height="20"
                        transform="translate(0.347656 0.750732)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                Пользователи
              </a>
            </li>
            <li
              class="navigation-item"
              :class="{ active: routeName === 'ReportsView' }"
            >
              <a @click.prevent="$router.push('/reports')">
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1_1566)">
                    <path
                      d="M18.4824 5.2025C18.4836 4.76449 18.3979 4.33059 18.2302 3.92593C18.0626 3.52126 17.8163 3.15387 17.5058 2.845L15.6374 0.976667C15.0113 0.353199 14.1643 0.00218954 13.2808 0L5.98242 0C5.31938 0 4.6835 0.263392 4.21466 0.732233C3.74581 1.20107 3.48242 1.83696 3.48242 2.5V20H18.4824V5.2025ZM16.3274 4.02333C16.3693 4.0688 16.4086 4.11666 16.4449 4.16667H14.3158V2.0375C14.3658 2.07387 14.4136 2.1131 14.4591 2.155L16.3274 4.02333ZM5.14909 18.3333V2.5C5.14909 2.27899 5.23689 2.06702 5.39317 1.91074C5.54945 1.75446 5.76141 1.66667 5.98242 1.66667H12.6491V5.83333H16.8158V18.3333H5.14909ZM7.64909 7.5H14.3158V9.16667H7.64909V7.5ZM7.64909 10.8333H14.3158V12.5H7.64909V10.8333ZM12.6641 14.0117L14.3016 14.3167C14.1424 15.1892 13.4641 16.6667 11.9283 16.6667C11.3254 16.6661 10.7411 16.4584 10.2733 16.0783C10.0116 15.8925 9.91992 15.8333 9.72159 15.8333C9.42326 15.9465 9.15999 16.1361 8.95826 16.3833L7.70826 15.2858C8.21232 14.67 8.93243 14.2697 9.72159 14.1667C10.2756 14.1733 10.8108 14.3684 11.2391 14.72C11.4259 14.896 11.6717 14.9959 11.9283 15C12.4474 15 12.6616 14.0225 12.6641 14.0117Z"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_1566">
                      <rect
                        width="20"
                        height="20"
                        transform="translate(0.982422)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                Отчеты
              </a>
            </li>
            <li
              v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
              class="navigation-item"
              :class="{ active: routeName === 'CarriersView' }"
            >
              <a @click.prevent="$router.push('/carriers')">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1_1570)">
                    <path
                      d="M19.9997 3.33359H5.83301V5.00025H19.9997V3.33359Z"
                    />
                    <path
                      d="M19.9997 9.16641H5.83301V10.8331H19.9997V9.16641Z"
                    />
                    <path d="M19.9997 15H5.83301V16.6667H19.9997V15Z" />
                    <path
                      d="M1.66618 5.83333C2.58665 5.83333 3.33285 5.08714 3.33285 4.16666C3.33285 3.24619 2.58665 2.5 1.66618 2.5C0.745704 2.5 -0.000488281 3.24619 -0.000488281 4.16666C-0.000488281 5.08714 0.745704 5.83333 1.66618 5.83333Z"
                    />
                    <path
                      d="M1.66618 11.6669C2.58665 11.6669 3.33285 10.9207 3.33285 10.0003C3.33285 9.07978 2.58665 8.33359 1.66618 8.33359C0.745704 8.33359 -0.000488281 9.07978 -0.000488281 10.0003C-0.000488281 10.9207 0.745704 11.6669 1.66618 11.6669Z"
                    />
                    <path
                      d="M1.66618 17.4997C2.58665 17.4997 3.33285 16.7535 3.33285 15.8331C3.33285 14.9126 2.58665 14.1664 1.66618 14.1664C0.745704 14.1664 -0.000488281 14.9126 -0.000488281 15.8331C-0.000488281 16.7535 0.745704 17.4997 1.66618 17.4997Z"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_1570">
                      <rect
                        width="20"
                        height="20"
                        transform="translate(-0.000488281)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                Перевозчики
              </a>
            </li>
            <li
              v-if="$store.state.user.roles.includes('ROLE_CONFIG')"
              class="navigation-item"
              :class="{ active: routeName === 'ConfigurationView' }"
            >
              <a @click.prevent="$router.push('/configuration')">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1_1574)">
                    <path
                      d="M9.10917 2.29194C8.9303 1.63383 8.53986 1.05286 7.99806 0.638668C7.45627 0.22447 6.79323 6.10352e-05 6.11125 6.10352e-05C5.42927 6.10352e-05 4.76623 0.22447 4.22444 0.638668C3.68264 1.05286 3.2922 1.63383 3.11333 2.29194H0V3.95861H3.11333C3.2922 4.61672 3.68264 5.19769 4.22444 5.61189C4.76623 6.02608 5.42927 6.25049 6.11125 6.25049C6.79323 6.25049 7.45627 6.02608 7.99806 5.61189C8.53986 5.19769 8.9303 4.61672 9.10917 3.95861H20V2.29194H9.10917ZM6.11083 4.58361C5.8224 4.58361 5.54045 4.49808 5.30063 4.33784C5.0608 4.17759 4.87389 3.94983 4.76351 3.68336C4.65313 3.41688 4.62425 3.12366 4.68052 2.84077C4.73679 2.55788 4.87568 2.29803 5.07964 2.09408C5.28359 1.89013 5.54344 1.75124 5.82633 1.69496C6.10922 1.63869 6.40244 1.66757 6.66891 1.77795C6.93539 1.88833 7.16315 2.07525 7.32339 2.31507C7.48364 2.55489 7.56917 2.83685 7.56917 3.12528C7.56851 3.51185 7.41465 3.8824 7.1413 4.15574C6.86795 4.42909 6.4974 4.58295 6.11083 4.58361V4.58361Z"
                    />
                    <path
                      d="M13.8892 6.875C13.2079 6.87744 12.5461 7.10275 12.0049 7.51654C11.4636 7.93033 11.0727 8.50986 10.8917 9.16667H0V10.8333H10.8917C11.0702 11.4916 11.4605 12.0728 12.0023 12.4871C12.544 12.9015 13.2071 13.126 13.8892 13.126C14.5712 13.126 15.2343 12.9015 15.7761 12.4871C16.3178 12.0728 16.7081 11.4916 16.8867 10.8333H20V9.16667H16.8867C16.7057 8.50986 16.3147 7.93033 15.7735 7.51654C15.2322 7.10275 14.5705 6.87744 13.8892 6.875V6.875ZM13.8892 11.4583C13.6007 11.4583 13.3188 11.3728 13.079 11.2126C12.8391 11.0523 12.6522 10.8246 12.5418 10.5581C12.4315 10.2916 12.4026 9.99838 12.4589 9.71549C12.5151 9.4326 12.654 9.17275 12.858 8.9688C13.0619 8.76485 13.3218 8.62596 13.6047 8.56969C13.8875 8.51342 14.1808 8.5423 14.4472 8.65268C14.7137 8.76305 14.9415 8.94997 15.1017 9.18979C15.262 9.42962 15.3475 9.71157 15.3475 10C15.3471 10.3866 15.1933 10.7573 14.9199 11.0307C14.6465 11.3041 14.2758 11.4579 13.8892 11.4583V11.4583Z"
                    />
                    <path
                      d="M6.11083 13.75C5.42912 13.7519 4.76677 13.977 4.22503 14.3908C3.68329 14.8046 3.29195 15.3844 3.11083 16.0417H0V17.7083H3.11333C3.2922 18.3664 3.68264 18.9474 4.22444 19.3616C4.76623 19.7758 5.42927 20.0002 6.11125 20.0002C6.79323 20.0002 7.45627 19.7758 7.99806 19.3616C8.53986 18.9474 8.9303 18.3664 9.10917 17.7083H20V16.0417H9.10917C8.92812 15.3847 8.53703 14.8051 7.99563 14.3913C7.45423 13.9775 6.79226 13.7523 6.11083 13.75ZM6.11083 18.3333C5.8224 18.3333 5.54045 18.2478 5.30063 18.0876C5.0608 17.9273 4.87389 17.6995 4.76351 17.4331C4.65313 17.1666 4.62425 16.8734 4.68052 16.5905C4.73679 16.3076 4.87568 16.0477 5.07964 15.8438C5.28359 15.6398 5.54344 15.501 5.82633 15.4447C6.10922 15.3884 6.40244 15.4173 6.66891 15.5277C6.93539 15.638 7.16315 15.825 7.32339 16.0648C7.48364 16.3046 7.56917 16.5866 7.56917 16.875C7.56851 17.2616 7.41465 17.6321 7.1413 17.9055C6.86795 18.1788 6.4974 18.3327 6.11083 18.3333V18.3333Z"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_1574">
                      <rect width="20" height="20" />
                    </clipPath>
                  </defs>
                </svg>
                Конфигурация
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="flex">
        <div class="user-info">
          <div
            v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
            class="user-info-admin"
          >
            Администратор
          </div>
          <div
            v-if="!$store.state.user.roles.includes('ROLE_ADMIN')"
            class="user-info-admin"
          >
            {{ "Диспетчер (" + $store.state.user.carrierName + ")" }}
          </div>
          <div class="user-info-name">{{ $store.state.user.email }}</div>
        </div>
        <Popper hover placement="bottom">
          <template #content>
            <div class="popup-popper">Уведомления</div>
          </template>
          <button
            class="icon-btn settings-btn"
            @click.prevent="$router.push('/notifications')"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1_5851)">
                <path
                  d="M23.2589 16.1999L20.6589 6.82893C20.1037 4.82435 18.894 3.06307 17.2222 1.82542C15.5504 0.587761 13.5127 -0.055148 11.4334 -0.000988358C9.35404 0.0531713 7.35257 0.801287 5.7475 2.12429C4.14243 3.4473 3.02601 5.26916 2.57592 7.29993L0.564915 16.3499C0.467608 16.7884 0.469982 17.2431 0.571861 17.6805C0.67374 18.1179 0.872525 18.5268 1.15355 18.8771C1.43457 19.2275 1.79067 19.5102 2.19556 19.7045C2.60045 19.8989 3.04381 19.9998 3.49292 19.9999H7.09992C7.32943 21.1302 7.94265 22.1464 8.83566 22.8763C9.72867 23.6062 10.8466 24.0049 11.9999 24.0049C13.1533 24.0049 14.2712 23.6062 15.1642 22.8763C16.0572 22.1464 16.6704 21.1302 16.8999 19.9999H20.3699C20.832 19.9997 21.2878 19.8928 21.7018 19.6874C22.1158 19.482 22.4767 19.1838 22.7564 18.816C23.0362 18.4482 23.2271 18.0207 23.3145 17.5669C23.4018 17.1131 23.3831 16.6453 23.2599 16.1999H23.2589ZM11.9999 21.9999C11.3817 21.9974 10.7793 21.8038 10.2752 21.4458C9.77115 21.0878 9.39 20.5828 9.18392 19.9999H14.8159C14.6098 20.5828 14.2287 21.0878 13.7246 21.4458C13.2205 21.8038 12.6182 21.9974 11.9999 21.9999ZM21.1649 17.6049C21.0716 17.7286 20.9507 17.8288 20.8118 17.8973C20.6729 17.9659 20.5198 18.0011 20.3649 17.9999H3.49292C3.34318 17.9999 3.19536 17.9663 3.06036 17.9015C2.92537 17.8367 2.80665 17.7424 2.71297 17.6256C2.61929 17.5087 2.55304 17.3724 2.5191 17.2265C2.48517 17.0807 2.48442 16.9291 2.51692 16.7829L4.52792 7.73293C4.88227 6.13914 5.75922 4.70953 7.01937 3.67138C8.27952 2.63322 9.85054 2.0461 11.4827 2.00334C13.1148 1.96058 14.7144 2.46465 16.0272 3.4354C17.34 4.40615 18.2906 5.78787 18.7279 7.36093L21.3279 16.7319C21.3704 16.8801 21.3777 17.0361 21.3494 17.1877C21.3212 17.3392 21.258 17.482 21.1649 17.6049Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_1_5851">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </Popper>
        <Popper
          v-if="!$store.state.user.roles.includes('ROLE_ADMIN')"
          hover
          placement="bottom"
        >
          <template #content>
            <div class="popup-popper">Telegram бот</div>
          </template>
          <a
            href="https://t.me/nlmk_notifications_bot"
            target="_blank"
            class="icon-btn"
            style="margin-right: 18px"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.25 12.1875C11.25 11.1521 10.4104 10.3125 9.375 10.3125H8.4375C6.36621 10.3125 4.6875 11.9912 4.6875 14.0625V16.875C4.6875 18.9463 6.36621 20.625 8.4375 20.625H9.375C10.4104 20.625 11.25 19.7854 11.25 18.75V12.1875ZM21.5625 20.625C23.6338 20.625 25.3125 18.9463 25.3125 16.875V14.0625C25.3125 11.9912 23.6338 10.3125 21.5625 10.3125H20.625C19.5896 10.3125 18.75 11.1521 18.75 12.1875V18.75C18.75 19.7854 19.5896 20.625 20.625 20.625H21.5625ZM15 0C6.63164 0 0.268359 6.9627 0 15V15.9375C0 16.4555 0.419531 16.875 0.9375 16.875H1.875C2.39297 16.875 2.8125 16.4555 2.8125 15.9375V15C2.8125 8.27988 8.27988 2.8125 15 2.8125C21.7201 2.8125 27.1875 8.27988 27.1875 15H27.1805C27.1852 15.1424 27.1875 24.7102 27.1875 24.7102C27.1875 26.0783 26.0783 27.1875 24.7102 27.1875H18.75C18.75 25.6342 17.4908 24.375 15.9375 24.375H14.0625C12.5092 24.375 11.25 25.6342 11.25 27.1875C11.25 28.7408 12.5092 30 14.0625 30H24.7102C27.6316 30 30 27.6316 30 24.7102V15C29.7316 6.9627 23.3684 0 15 0Z"
                fill="white"
              />
            </svg>
          </a>
        </Popper>
        <Popper hover placement="bottom">
          <template #content>
            <div class="popup-popper">Выйти</div>
          </template>
          <button class="icon-btn logout-btn" @click="logout">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1_1584)">
                <path
                  d="M14.9995 2.42673V4.52673C17.0012 5.23441 18.6882 6.62693 19.7624 8.45817C20.8367 10.2894 21.2289 12.4414 20.8699 14.5339C20.5109 16.6264 19.4237 18.5246 17.8005 19.893C16.1773 21.2615 14.1226 22.012 11.9995 22.012C9.87648 22.012 7.82176 21.2615 6.19856 19.893C4.57535 18.5246 3.48816 16.6264 3.12915 14.5339C2.77014 12.4414 3.16241 10.2894 4.23664 8.45817C5.31087 6.62693 6.9979 5.23441 8.99954 4.52673V2.42673C6.44516 3.15083 4.23887 4.77437 2.78778 6.99778C1.3367 9.22119 0.738755 11.8944 1.10429 14.5242C1.46982 17.1539 2.77415 19.5627 4.77661 21.3061C6.77907 23.0494 9.34451 24.0097 11.9995 24.0097C14.6546 24.0097 17.22 23.0494 19.2225 21.3061C21.2249 19.5627 22.5293 17.1539 22.8948 14.5242C23.2603 11.8944 22.6624 9.22119 21.2113 6.99778C19.7602 4.77437 17.5539 3.15083 14.9995 2.42673Z"
                  fill="white"
                />
                <path d="M12.9995 0H10.9995V8H12.9995V0Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_1_1584">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </Popper>
      </div>
    </div>
    <transition name="fade">
      <div
        v-if="openBurgerMenu"
        class="mobile-nav"
        @click="openBurgerMenu = false"
      >
        <div @click.stop class="mobile-nav-container">
          <div class="mobile-top flex">
            <div class="flex">
              <button @click="openBurgerMenu = false" class="burger-close">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_516_1513)">
                    <path
                      d="M24 1.414L22.586 0L12 10.586L1.414 0L0 1.414L10.586 12L0 22.586L1.414 24L12 13.414L22.586 24L24 22.586L13.414 12L24 1.414Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_516_1513">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <!--              <img class="logo" src="../assets/images/geologistic_logo_white_all.png" alt="logo">-->
            </div>
            <div class="flex">
              <div class="user-info">
                <div
                  v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
                  class="user-info-admin"
                >
                  Администратор
                </div>
                <div
                  v-if="!$store.state.user.roles.includes('ROLE_ADMIN')"
                  class="user-info-admin"
                >
                  {{ "Диспетчер (" + $store.state.user.carrierName + ")" }}
                </div>
                <div class="user-info-name">{{ $store.state.user.email }}</div>
              </div>
              <Popper hover placement="bottom">
                <template #content>
                  <div class="popup-popper">Уведомления</div>
                </template>
                <button
                  class="icon-btn settings-btn"
                  @click.prevent="$router.push('/notifications')"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1_5851)">
                      <path
                        d="M23.2589 16.1999L20.6589 6.82893C20.1037 4.82435 18.894 3.06307 17.2222 1.82542C15.5504 0.587761 13.5127 -0.055148 11.4334 -0.000988358C9.35404 0.0531713 7.35257 0.801287 5.7475 2.12429C4.14243 3.4473 3.02601 5.26916 2.57592 7.29993L0.564915 16.3499C0.467608 16.7884 0.469982 17.2431 0.571861 17.6805C0.67374 18.1179 0.872525 18.5268 1.15355 18.8771C1.43457 19.2275 1.79067 19.5102 2.19556 19.7045C2.60045 19.8989 3.04381 19.9998 3.49292 19.9999H7.09992C7.32943 21.1302 7.94265 22.1464 8.83566 22.8763C9.72867 23.6062 10.8466 24.0049 11.9999 24.0049C13.1533 24.0049 14.2712 23.6062 15.1642 22.8763C16.0572 22.1464 16.6704 21.1302 16.8999 19.9999H20.3699C20.832 19.9997 21.2878 19.8928 21.7018 19.6874C22.1158 19.482 22.4767 19.1838 22.7564 18.816C23.0362 18.4482 23.2271 18.0207 23.3145 17.5669C23.4018 17.1131 23.3831 16.6453 23.2599 16.1999H23.2589ZM11.9999 21.9999C11.3817 21.9974 10.7793 21.8038 10.2752 21.4458C9.77115 21.0878 9.39 20.5828 9.18392 19.9999H14.8159C14.6098 20.5828 14.2287 21.0878 13.7246 21.4458C13.2205 21.8038 12.6182 21.9974 11.9999 21.9999ZM21.1649 17.6049C21.0716 17.7286 20.9507 17.8288 20.8118 17.8973C20.6729 17.9659 20.5198 18.0011 20.3649 17.9999H3.49292C3.34318 17.9999 3.19536 17.9663 3.06036 17.9015C2.92537 17.8367 2.80665 17.7424 2.71297 17.6256C2.61929 17.5087 2.55304 17.3724 2.5191 17.2265C2.48517 17.0807 2.48442 16.9291 2.51692 16.7829L4.52792 7.73293C4.88227 6.13914 5.75922 4.70953 7.01937 3.67138C8.27952 2.63322 9.85054 2.0461 11.4827 2.00334C13.1148 1.96058 14.7144 2.46465 16.0272 3.4354C17.34 4.40615 18.2906 5.78787 18.7279 7.36093L21.3279 16.7319C21.3704 16.8801 21.3777 17.0361 21.3494 17.1877C21.3212 17.3392 21.258 17.482 21.1649 17.6049Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_5851">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </Popper>
              <Popper
                v-if="!$store.state.user.roles.includes('ROLE_ADMIN')"
                hover
                placement="bottom"
              >
                <template #content>
                  <div class="popup-popper">Telegram бот</div>
                </template>
                <a
                  href="https://t.me/nlmk_notifications_bot"
                  target="_blank"
                  class="icon-btn"
                  style="margin-right: 18px"
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.25 12.1875C11.25 11.1521 10.4104 10.3125 9.375 10.3125H8.4375C6.36621 10.3125 4.6875 11.9912 4.6875 14.0625V16.875C4.6875 18.9463 6.36621 20.625 8.4375 20.625H9.375C10.4104 20.625 11.25 19.7854 11.25 18.75V12.1875ZM21.5625 20.625C23.6338 20.625 25.3125 18.9463 25.3125 16.875V14.0625C25.3125 11.9912 23.6338 10.3125 21.5625 10.3125H20.625C19.5896 10.3125 18.75 11.1521 18.75 12.1875V18.75C18.75 19.7854 19.5896 20.625 20.625 20.625H21.5625ZM15 0C6.63164 0 0.268359 6.9627 0 15V15.9375C0 16.4555 0.419531 16.875 0.9375 16.875H1.875C2.39297 16.875 2.8125 16.4555 2.8125 15.9375V15C2.8125 8.27988 8.27988 2.8125 15 2.8125C21.7201 2.8125 27.1875 8.27988 27.1875 15H27.1805C27.1852 15.1424 27.1875 24.7102 27.1875 24.7102C27.1875 26.0783 26.0783 27.1875 24.7102 27.1875H18.75C18.75 25.6342 17.4908 24.375 15.9375 24.375H14.0625C12.5092 24.375 11.25 25.6342 11.25 27.1875C11.25 28.7408 12.5092 30 14.0625 30H24.7102C27.6316 30 30 27.6316 30 24.7102V15C29.7316 6.9627 23.3684 0 15 0Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </Popper>
              <Popper hover placement="bottom">
                <template #content>
                  <div class="popup-popper">Выйти</div>
                </template>
                <button class="icon-btn logout-btn" @click="logout">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1_1584)">
                      <path
                        d="M14.9995 2.42673V4.52673C17.0012 5.23441 18.6882 6.62693 19.7624 8.45817C20.8367 10.2894 21.2289 12.4414 20.8699 14.5339C20.5109 16.6264 19.4237 18.5246 17.8005 19.893C16.1773 21.2615 14.1226 22.012 11.9995 22.012C9.87648 22.012 7.82176 21.2615 6.19856 19.893C4.57535 18.5246 3.48816 16.6264 3.12915 14.5339C2.77014 12.4414 3.16241 10.2894 4.23664 8.45817C5.31087 6.62693 6.9979 5.23441 8.99954 4.52673V2.42673C6.44516 3.15083 4.23887 4.77437 2.78778 6.99778C1.3367 9.22119 0.738755 11.8944 1.10429 14.5242C1.46982 17.1539 2.77415 19.5627 4.77661 21.3061C6.77907 23.0494 9.34451 24.0097 11.9995 24.0097C14.6546 24.0097 17.22 23.0494 19.2225 21.3061C21.2249 19.5627 22.5293 17.1539 22.8948 14.5242C23.2603 11.8944 22.6624 9.22119 21.2113 6.99778C19.7602 4.77437 17.5539 3.15083 14.9995 2.42673Z"
                        fill="white"
                      />
                      <path d="M12.9995 0H10.9995V8H12.9995V0Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_1584">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </Popper>
            </div>
          </div>
          <div class="mobile-user-info">
            <div
              v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
              class="user-info-admin"
            >
              Администратор
            </div>
            <div
              v-if="!$store.state.user.roles.includes('ROLE_ADMIN')"
              class="user-info-admin"
            >
              {{ "Диспетчер (" + $store.state.user.carrierName + ")" }}
            </div>
            <div class="user-info-name">{{ $store.state.user.email }}</div>
          </div>
          <nav class="mobile-navigation">
            <ul>
              <li
                class="navigation-item"
                :class="{ active: routeName === 'MonitoringView' }"
              >
                <a @click.prevent="$router.push('/monitoring')">
                  <span class="icon-container">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.8531 10.4986C11.5059 10.4986 12.1441 10.3031 12.6869 9.9368C13.2297 9.57053 13.6527 9.04994 13.9025 8.44085C14.1524 7.83176 14.2177 7.16154 14.0904 6.51494C13.963 5.86833 13.6487 5.27439 13.187 4.80821C12.7254 4.34204 12.1373 4.02457 11.4971 3.89595C10.8568 3.76734 10.1931 3.83335 9.59003 4.08564C8.98691 4.33793 8.47142 4.76517 8.10874 5.31334C7.74606 5.8615 7.55248 6.50597 7.55248 7.16524C7.55248 8.04929 7.90023 8.89714 8.51922 9.52226C9.13821 10.1474 9.97775 10.4986 10.8531 10.4986ZM10.8531 5.49857C11.1795 5.49857 11.4986 5.59632 11.77 5.77946C12.0414 5.96259 12.2529 6.22289 12.3778 6.52743C12.5027 6.83198 12.5354 7.16709 12.4718 7.49039C12.4081 7.81369 12.2509 8.11066 12.0201 8.34375C11.7893 8.57684 11.4952 8.73557 11.1751 8.79988C10.855 8.86419 10.5231 8.83118 10.2216 8.70504C9.92002 8.57889 9.66228 8.36527 9.48094 8.09119C9.2996 7.81711 9.20281 7.49487 9.20281 7.16524C9.20281 6.72321 9.37668 6.29929 9.68618 5.98673C9.99567 5.67417 10.4154 5.49857 10.8531 5.49857ZM14.1538 18.8569L20.7551 20.4802V11.7344C20.7549 11.1976 20.5837 10.6752 20.2667 10.2443C19.9497 9.81343 19.5039 9.49703 18.995 9.34191L17.2622 8.75857C17.3889 8.23879 17.4534 7.70554 17.4544 7.17024C17.4544 5.40213 16.759 3.70643 15.521 2.45619C14.283 1.20595 12.6039 0.503571 10.8531 0.503571C9.10236 0.503571 7.42329 1.20595 6.18531 2.45619C4.94732 3.70643 4.25183 5.40213 4.25183 7.17024C4.25427 7.50852 4.28185 7.84613 4.33434 8.18024C3.95961 8.02937 3.55398 7.97353 3.15293 8.01761C2.75189 8.06169 2.36765 8.20435 2.03382 8.4331C1.7 8.66185 1.42677 8.96973 1.23804 9.3298C1.0493 9.68987 0.950806 10.0912 0.951173 10.4986V18.6252L7.53845 20.5261L14.1538 18.8569ZM7.35197 3.63524C8.28213 2.7092 9.53695 2.19188 10.8431 2.19597C12.1492 2.20006 13.4008 2.72523 14.3253 3.65708C15.2498 4.58893 15.7721 5.85195 15.7787 7.17101C15.7852 8.49007 15.2753 9.75829 14.3601 10.6994L10.8531 14.1652L7.35197 10.7061C6.42355 9.7684 5.90197 8.49668 5.90197 7.17066C5.90197 5.84463 6.42355 4.57291 7.35197 3.63524V3.63524ZM2.6015 10.4986C2.60046 10.3611 2.63361 10.2256 2.69791 10.1045C2.76221 9.98334 2.8556 9.88045 2.96952 9.80524C3.08869 9.72626 3.22597 9.67956 3.36816 9.66964C3.51036 9.65971 3.65269 9.68689 3.78148 9.74857L4.96477 10.1802C5.28135 10.8134 5.69552 11.3917 6.19179 11.8936L10.8531 16.4986L15.5211 11.8877C15.9801 11.4249 16.3693 10.8965 16.6763 10.3194L18.5057 10.9369C18.678 10.9867 18.8296 11.0917 18.9375 11.2362C19.0454 11.3807 19.1039 11.5568 19.1039 11.7377V18.3619L14.1538 17.1402L7.56898 18.8069L2.6015 17.3702V10.4986Z"
                      />
                    </svg>
                  </span>
                  Мониторинг
                </a>
              </li>
              <li
                class="navigation-item"
                :class="{ active: routeName === 'ObjectsView' }"
              >
                <a @click.prevent="$router.push('/objects')">
                  <span class="icon-container">
                    <svg
                      width="18"
                      height="20"
                      viewBox="0 0 18 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1_1558)">
                        <path
                          d="M14.1033 4.16616H12.6485V3.33282C12.6485 2.66978 12.4186 2.0339 12.0094 1.56506C11.6001 1.09622 11.0451 0.832825 10.4663 0.832825H2.46492C1.88616 0.832825 1.33111 1.09622 0.921867 1.56506C0.512625 2.0339 0.282715 2.66978 0.282715 3.33282L0.282715 15.8328H1.76734C1.74862 15.9707 1.73866 16.11 1.73752 16.2495C1.73752 17.023 2.00575 17.7649 2.48319 18.3119C2.96064 18.8589 3.60821 19.1662 4.28342 19.1662C4.95864 19.1662 5.6062 18.8589 6.08365 18.3119C6.5611 17.7649 6.82932 17.023 6.82932 16.2495C6.82818 16.11 6.81822 15.9707 6.7995 15.8328H11.2236C11.2048 15.9707 11.1949 16.11 11.1937 16.2495C11.1937 17.023 11.462 17.7649 11.9394 18.3119C12.4169 18.8589 13.0644 19.1662 13.7396 19.1662C14.4149 19.1662 15.0624 18.8589 15.5399 18.3119C16.0173 17.7649 16.2855 17.023 16.2855 16.2495C16.2844 16.11 16.2744 15.9707 16.2557 15.8328H17.7403V8.33282C17.7392 7.22816 17.3556 6.16912 16.6738 5.38801C15.992 4.60689 15.0676 4.16748 14.1033 4.16616ZM14.1033 5.83282C14.6821 5.83282 15.2371 6.09622 15.6464 6.56506C16.0556 7.0339 16.2855 7.66978 16.2855 8.33282V9.16616H12.6485V5.83282H14.1033ZM5.37452 16.2495C5.37452 16.581 5.25957 16.899 5.05495 17.1334C4.85033 17.3678 4.5728 17.4995 4.28342 17.4995C3.99404 17.4995 3.71652 17.3678 3.5119 17.1334C3.30727 16.899 3.19232 16.581 3.19232 16.2495C3.19277 16.1071 3.21568 15.9659 3.25997 15.8328H5.30687C5.35116 15.9659 5.37408 16.1071 5.37452 16.2495ZM11.1937 14.1662H1.73752V3.33282C1.73752 3.11181 1.81415 2.89985 1.95057 2.74357C2.08698 2.58729 2.272 2.49949 2.46492 2.49949H10.4663C10.6592 2.49949 10.8443 2.58729 10.9807 2.74357C11.1171 2.89985 11.1937 3.11181 11.1937 3.33282V14.1662ZM14.8307 16.2495C14.8307 16.581 14.7158 16.899 14.5112 17.1334C14.3065 17.3678 14.029 17.4995 13.7396 17.4995C13.4503 17.4995 13.1727 17.3678 12.9681 17.1334C12.7635 16.899 12.6485 16.581 12.6485 16.2495C12.6489 16.1071 12.6718 15.9659 12.7162 15.8328H14.7631C14.8075 15.9659 14.8304 16.1071 14.8307 16.2495ZM12.6485 14.1662V10.8328H16.2855V14.1662H12.6485Z"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_1558">
                          <rect
                            width="17.4576"
                            height="20"
                            transform="translate(0.282715)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  Объекты
                </a>
              </li>
              <li
                v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
                class="navigation-item"
                :class="{ active: routeName === 'UsersView' }"
              >
                <a @click.prevent="$router.push('/users')">
                  <span class="icon-container">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1_1562)">
                        <path
                          d="M17.8316 20.7512H16.1664V16.5487C16.1658 15.8954 15.9062 15.269 15.4446 14.807C14.9831 14.3451 14.3572 14.0852 13.7045 14.0846H6.97229C6.31955 14.0852 5.69374 14.3451 5.23218 14.807C4.77062 15.269 4.51103 15.8954 4.51037 16.5487V20.7512H2.84521V16.5487C2.84654 15.4536 3.28178 14.4037 4.05547 13.6293C4.82916 12.8549 5.87813 12.4192 6.97229 12.4179H13.7045C14.7987 12.4192 15.8476 12.8549 16.6213 13.6293C17.395 14.4037 17.8303 15.4536 17.8316 16.5487V20.7512Z"
                        />
                        <path
                          d="M10.3382 10.7507C9.35022 10.7507 8.3844 10.4574 7.5629 9.90802C6.74141 9.35861 6.10113 8.57772 5.72303 7.66409C5.34494 6.75046 5.24601 5.74513 5.43876 4.77522C5.63151 3.80532 6.10728 2.9144 6.80591 2.21514C7.50454 1.51588 8.39464 1.03967 9.36367 0.846747C10.3327 0.653821 11.3371 0.752838 12.2499 1.13128C13.1627 1.50971 13.9429 2.15058 14.4918 2.97282C15.0407 3.79507 15.3337 4.76177 15.3337 5.75067C15.3324 7.07635 14.8056 8.34735 13.8691 9.28475C12.9325 10.2221 11.6627 10.7493 10.3382 10.7507V10.7507ZM10.3382 2.41734C9.67956 2.41734 9.03568 2.61284 8.48801 2.97911C7.94035 3.34538 7.51349 3.86598 7.26143 4.47506C7.00937 5.08415 6.94342 5.75437 7.07192 6.40097C7.20042 7.04758 7.5176 7.64152 7.98335 8.1077C8.4491 8.57387 9.0425 8.89134 9.68852 9.01996C10.3345 9.14858 11.0041 9.08256 11.6127 8.83027C12.2212 8.57798 12.7413 8.15074 13.1073 7.60257C13.4732 7.05441 13.6685 6.40994 13.6685 5.75067C13.6685 4.86662 13.3177 4.01877 12.6931 3.39365C12.0686 2.76853 11.2215 2.41734 10.3382 2.41734Z"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_1562">
                          <rect
                            width="19.9818"
                            height="20"
                            transform="translate(0.347656 0.750732)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  Пользователи
                </a>
              </li>
              <li
                class="navigation-item"
                :class="{ active: routeName === 'ReportsView' }"
              >
                <a @click.prevent="$router.push('/reports')">
                  <span class="icon-container">
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1_1566)">
                        <path
                          d="M18.4824 5.2025C18.4836 4.76449 18.3979 4.33059 18.2302 3.92593C18.0626 3.52126 17.8163 3.15387 17.5058 2.845L15.6374 0.976667C15.0113 0.353199 14.1643 0.00218954 13.2808 0L5.98242 0C5.31938 0 4.6835 0.263392 4.21466 0.732233C3.74581 1.20107 3.48242 1.83696 3.48242 2.5V20H18.4824V5.2025ZM16.3274 4.02333C16.3693 4.0688 16.4086 4.11666 16.4449 4.16667H14.3158V2.0375C14.3658 2.07387 14.4136 2.1131 14.4591 2.155L16.3274 4.02333ZM5.14909 18.3333V2.5C5.14909 2.27899 5.23689 2.06702 5.39317 1.91074C5.54945 1.75446 5.76141 1.66667 5.98242 1.66667H12.6491V5.83333H16.8158V18.3333H5.14909ZM7.64909 7.5H14.3158V9.16667H7.64909V7.5ZM7.64909 10.8333H14.3158V12.5H7.64909V10.8333ZM12.6641 14.0117L14.3016 14.3167C14.1424 15.1892 13.4641 16.6667 11.9283 16.6667C11.3254 16.6661 10.7411 16.4584 10.2733 16.0783C10.0116 15.8925 9.91992 15.8333 9.72159 15.8333C9.42326 15.9465 9.15999 16.1361 8.95826 16.3833L7.70826 15.2858C8.21232 14.67 8.93243 14.2697 9.72159 14.1667C10.2756 14.1733 10.8108 14.3684 11.2391 14.72C11.4259 14.896 11.6717 14.9959 11.9283 15C12.4474 15 12.6616 14.0225 12.6641 14.0117Z"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_1566">
                          <rect
                            width="20"
                            height="20"
                            transform="translate(0.982422)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  Отчеты
                </a>
              </li>
              <li
                v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
                class="navigation-item"
                :class="{ active: routeName === 'CarriersView' }"
              >
                <a @click.prevent="$router.push('/carriers')">
                  <span class="icon-container">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1_1570)">
                        <path
                          d="M19.9997 3.33359H5.83301V5.00025H19.9997V3.33359Z"
                        />
                        <path
                          d="M19.9997 9.16641H5.83301V10.8331H19.9997V9.16641Z"
                        />
                        <path d="M19.9997 15H5.83301V16.6667H19.9997V15Z" />
                        <path
                          d="M1.66618 5.83333C2.58665 5.83333 3.33285 5.08714 3.33285 4.16666C3.33285 3.24619 2.58665 2.5 1.66618 2.5C0.745704 2.5 -0.000488281 3.24619 -0.000488281 4.16666C-0.000488281 5.08714 0.745704 5.83333 1.66618 5.83333Z"
                        />
                        <path
                          d="M1.66618 11.6669C2.58665 11.6669 3.33285 10.9207 3.33285 10.0003C3.33285 9.07978 2.58665 8.33359 1.66618 8.33359C0.745704 8.33359 -0.000488281 9.07978 -0.000488281 10.0003C-0.000488281 10.9207 0.745704 11.6669 1.66618 11.6669Z"
                        />
                        <path
                          d="M1.66618 17.4997C2.58665 17.4997 3.33285 16.7535 3.33285 15.8331C3.33285 14.9126 2.58665 14.1664 1.66618 14.1664C0.745704 14.1664 -0.000488281 14.9126 -0.000488281 15.8331C-0.000488281 16.7535 0.745704 17.4997 1.66618 17.4997Z"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_1570">
                          <rect
                            width="20"
                            height="20"
                            transform="translate(-0.000488281)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  Перевозчики
                </a>
              </li>
              <li
                v-if="$store.state.user.roles.includes('ROLE_CONFIG')"
                class="navigation-item"
                :class="{ active: routeName === 'ConfigurationView' }"
              >
                <a @click.prevent="$router.push('/configuration')">
                  <span class="icon-container">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1_1574)">
                        <path
                          d="M9.10917 2.29194C8.9303 1.63383 8.53986 1.05286 7.99806 0.638668C7.45627 0.22447 6.79323 6.10352e-05 6.11125 6.10352e-05C5.42927 6.10352e-05 4.76623 0.22447 4.22444 0.638668C3.68264 1.05286 3.2922 1.63383 3.11333 2.29194H0V3.95861H3.11333C3.2922 4.61672 3.68264 5.19769 4.22444 5.61189C4.76623 6.02608 5.42927 6.25049 6.11125 6.25049C6.79323 6.25049 7.45627 6.02608 7.99806 5.61189C8.53986 5.19769 8.9303 4.61672 9.10917 3.95861H20V2.29194H9.10917ZM6.11083 4.58361C5.8224 4.58361 5.54045 4.49808 5.30063 4.33784C5.0608 4.17759 4.87389 3.94983 4.76351 3.68336C4.65313 3.41688 4.62425 3.12366 4.68052 2.84077C4.73679 2.55788 4.87568 2.29803 5.07964 2.09408C5.28359 1.89013 5.54344 1.75124 5.82633 1.69496C6.10922 1.63869 6.40244 1.66757 6.66891 1.77795C6.93539 1.88833 7.16315 2.07525 7.32339 2.31507C7.48364 2.55489 7.56917 2.83685 7.56917 3.12528C7.56851 3.51185 7.41465 3.8824 7.1413 4.15574C6.86795 4.42909 6.4974 4.58295 6.11083 4.58361V4.58361Z"
                        />
                        <path
                          d="M13.8892 6.875C13.2079 6.87744 12.5461 7.10275 12.0049 7.51654C11.4636 7.93033 11.0727 8.50986 10.8917 9.16667H0V10.8333H10.8917C11.0702 11.4916 11.4605 12.0728 12.0023 12.4871C12.544 12.9015 13.2071 13.126 13.8892 13.126C14.5712 13.126 15.2343 12.9015 15.7761 12.4871C16.3178 12.0728 16.7081 11.4916 16.8867 10.8333H20V9.16667H16.8867C16.7057 8.50986 16.3147 7.93033 15.7735 7.51654C15.2322 7.10275 14.5705 6.87744 13.8892 6.875V6.875ZM13.8892 11.4583C13.6007 11.4583 13.3188 11.3728 13.079 11.2126C12.8391 11.0523 12.6522 10.8246 12.5418 10.5581C12.4315 10.2916 12.4026 9.99838 12.4589 9.71549C12.5151 9.4326 12.654 9.17275 12.858 8.9688C13.0619 8.76485 13.3218 8.62596 13.6047 8.56969C13.8875 8.51342 14.1808 8.5423 14.4472 8.65268C14.7137 8.76305 14.9415 8.94997 15.1017 9.18979C15.262 9.42962 15.3475 9.71157 15.3475 10C15.3471 10.3866 15.1933 10.7573 14.9199 11.0307C14.6465 11.3041 14.2758 11.4579 13.8892 11.4583V11.4583Z"
                        />
                        <path
                          d="M6.11083 13.75C5.42912 13.7519 4.76677 13.977 4.22503 14.3908C3.68329 14.8046 3.29195 15.3844 3.11083 16.0417H0V17.7083H3.11333C3.2922 18.3664 3.68264 18.9474 4.22444 19.3616C4.76623 19.7758 5.42927 20.0002 6.11125 20.0002C6.79323 20.0002 7.45627 19.7758 7.99806 19.3616C8.53986 18.9474 8.9303 18.3664 9.10917 17.7083H20V16.0417H9.10917C8.92812 15.3847 8.53703 14.8051 7.99563 14.3913C7.45423 13.9775 6.79226 13.7523 6.11083 13.75ZM6.11083 18.3333C5.8224 18.3333 5.54045 18.2478 5.30063 18.0876C5.0608 17.9273 4.87389 17.6995 4.76351 17.4331C4.65313 17.1666 4.62425 16.8734 4.68052 16.5905C4.73679 16.3076 4.87568 16.0477 5.07964 15.8438C5.28359 15.6398 5.54344 15.501 5.82633 15.4447C6.10922 15.3884 6.40244 15.4173 6.66891 15.5277C6.93539 15.638 7.16315 15.825 7.32339 16.0648C7.48364 16.3046 7.56917 16.5866 7.56917 16.875C7.56851 17.2616 7.41465 17.6321 7.1413 17.9055C6.86795 18.1788 6.4974 18.3327 6.11083 18.3333V18.3333Z"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_1574">
                          <rect width="20" height="20" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  Конфигурация
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Swal from "@/sweetalert2";
import router from "@/router";

export default {
  name: "NavigationView",
  beforeMount() {
    this.routeName = this.$route.name;
  },
  data() {
    return {
      routeName: "",
      openBurgerMenu: false,
    };
  },
  methods: {
    router() {
      return router;
    },
    async logout() {
      var result = await Swal.fire({
        title: "Вы уверены, что хотите выйти?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#28bd4a",
        cancelButtonColor: "#005291",
        cancelButtonText: "Отмена",
        confirmButtonText: "Выйти",
      });
      if (result.isConfirmed) {
        localStorage.removeItem("auth-token");
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style scoped>
.block-container {
  width: 100%;
  background: #005291;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 2.5rem;
}

.flex {
  display: flex;
  align-items: center;
}

.logo {
  max-width: 135px;
  margin-right: 1.5rem;
}

.inline-block {
  flex-shrink: 0;
}

.navigation ul {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
}

.navigation-item a {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-bottom: 7px;
  font-size: 16px;
  flex-direction: column;
  line-height: 24px;
  color: #9ec8e4 !important;
  position: relative;
  transition: all 0.4s;
}

.navigation-item a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #9bcbeb;
  height: 3px;
  border-radius: 10px 10px 0 0;
  transition: all 0.4s;
}

.navigation-item.active a,
.navigation-item:hover a {
  color: #ffffff !important;
}

.navigation-item.active a::after {
  background: #ffffff;
}

.navigation-item {
  margin: 0 16px;
  height: 50px;
}

.navigation-item svg {
  fill: #9ec8e4;
  transition: all 0.4s;
  flex-shrink: 0;
}

.navigation-item.active svg,
.navigation-item:hover svg {
  fill: #ffffff;
}

.mobile-navigation ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mobile-navigation .navigation-item {
  margin: 0;
  padding: 0;
}

.mobile-navigation .navigation-item a {
  padding: 14px 0;
}

.mobile-navigation .navigation-item a::after {
  content: none;
}

.user-info-admin {
  font-size: 13px;
  color: #b2cbde;
  height: 19px;
}

.user-info-name {
  font-size: 13px;
  color: #ffffff;
  font-family: OpenSansSemiBold, sans-serif;
  height: 19px;
}

.icon-btn {
  background: none;
  border: 0;
  outline: none;
  cursor: pointer;
  transition: all 0.4s;
  flex-shrink: 0;
}

.icon-btn svg {
  max-width: 100%;
}

.icon-btn svg:hover {
  transform: scale(0.95);
} 

.icon-btn:hover {
  transform: scale(0.95);
}

.settings-btn {
  margin: 0 20px;
}

.burger {
  display: none;
  background: none;
  border: 0;
  outline: none;
  cursor: pointer;
  transition: all 0.4s;
  flex-shrink: 0;
  margin-right: 10px;
}

.burger:active {
  transform: scale(0.95);
}

.burger-close {
  background: none;
  border: 0;
  outline: none;
  cursor: pointer;
  transition: all 0.4s;
  flex-shrink: 0;
  margin-right: 10px;
}

.burger-close:active {
  transform: scale(0.95);
}

.mobile-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(77, 84, 96, 0.7);
  /*background: rgba(44, 86, 151, 0.4);*/
  /*backdrop-filter: blur(2px);*/
  z-index: 998;
  overflow: auto;
}

.mobile-nav-container {
  width: 100%;
  background: #005291;
  padding: 0 30px 20px 20px;
  border-radius: 0 0 16px 16px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 21px;
  height: 21px;
  margin-right: 7px;
}

.icon-container svg {
  margin-right: 0;
}

.mobile-top {
  height: 60px;
  justify-content: space-between;
}

.mobile-user-info {
  display: none;
}

.fade-enter-active {
  animation: fade-in 0.3s;
}

.fade-leave-active {
  animation: fade-in 0.3s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* < 1440 */
@media screen and (max-width: 1439px) {
  .navigation-item {
    margin: 0 8px;
  }
}

/* < 1300 */
@media screen and (max-width: 1299px) {
  .navigation-item {
    margin: 0 6px;
  }
  .user-info-name {
    font-size: 12px;
  }
  .navigation-item a {
    font-size: 13px;
  }
}

/* < 1200 */
@media screen and (max-width: 1199px) {
  .user-info-name {
    font-size: 13px;
  }
  .navigation-item a {
    font-size: 14px;
  }
  .navigation {
    display: none;
  }

  .burger {
    display: block;
  }
}

/* < 768 */
@media screen and (max-width: 767px) {
  .block-container {
    padding: 0 15px 0 15px;
  }

  .mobile-nav-container {
    padding: 0 15px 15px 15px;
  }

  .user-info {
    display: none;
  }

  .mobile-user-info {
    display: block;
  }
}

/* < 345 */
@media screen and (max-width: 344px) {
  .logo {
    max-width: 120px;
  }
}
</style>
